export default __webpack_public_path__ + "static/media/step-3.2392661b.jpeg";